import { Link } from "react-router-dom";
import { useResolvedDark } from "../../ThemeProvider/ThemeContext";

const skeletonRows = [70, 52, 88, 46];

const CoTraderDemoLockedChatPanel = ({
  assistantLabel = "EMGPT",
  isDark: isDarkProp,
}) => {
  const isDark = useResolvedDark(isDarkProp);
  const theme = isDark
    ? {
        surface: "#12172A",
        border: "#232B4A",
        text: "#E8ECF8",
        muted: "#A6B0CF",
        bubble: "rgba(255,255,255,0.06)",
        bubbleAlt: "rgba(76,125,255,0.18)",
        overlay: "rgba(11,15,26,0.72)",
        button: "#4C7DFF",
      }
    : {
        surface: "#FFFFFF",
        border: "#E5EAF1",
        text: "#0B1220",
        muted: "#5B6472",
        bubble: "#F4F7FB",
        bubbleAlt: "rgba(13,110,253,0.10)",
        overlay: "rgba(255,255,255,0.82)",
        button: "#0D6EFD",
      };

  return (
    <div
      className="h-100 position-relative d-flex flex-column"
      style={{ minHeight: 0, background: theme.surface }}
    >
      <div className="d-flex align-items-center justify-content-between px-2 pb-3">
        <div>
          <div>
            <div style={{ color: theme.text, fontWeight: 700 }}>
              {assistantLabel}
            </div>
            <div style={{ color: theme.muted, fontSize: "0.86rem" }}>
              Private chat workspace
            </div>
          </div>
        </div>
        <div
          className="rounded-pill px-3 py-2"
          style={{
            border: `1px solid ${theme.border}`,
            color: theme.muted,
            fontSize: "0.78rem",
            fontWeight: 700,
          }}
        >
          Locked
        </div>
      </div>

      <div className="flex-grow-1 d-flex flex-column gap-3" style={{ minHeight: 0 }}>
        {skeletonRows.map((width, index) => (
          <div
            key={`${assistantLabel}-${width}-${index}`}
            className="rounded-4"
            style={{
              width: `${width}%`,
              minHeight: index % 2 === 0 ? 72 : 56,
              alignSelf: index % 2 === 0 ? "flex-start" : "flex-end",
              background: index % 2 === 0 ? theme.bubble : theme.bubbleAlt,
              border: `1px solid ${theme.border}`,
            }}
          />
        ))}
      </div>

      <div
        className="mt-3 rounded-4 px-3 py-3 d-flex align-items-center justify-content-between"
        style={{
          border: `1px solid ${theme.border}`,
          background: theme.bubble,
          color: theme.muted,
        }}
      >
        <span>Ask a question about this instrument...</span>
        <span style={{ fontWeight: 700 }}>Enter</span>
      </div>

      <div
        className="position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center p-3"
        style={{ background: theme.overlay, backdropFilter: "blur(3px)" }}
      >
        <div
          className="rounded-4 text-center px-4 py-4"
          style={{
            maxWidth: 360,
            background: theme.surface,
            border: `1px solid ${theme.border}`,
            boxShadow: "0 18px 40px rgba(15, 23, 42, 0.12)",
          }}
        >
          <div style={{ color: theme.text, fontWeight: 700, fontSize: "1rem" }}>
            Please sign up to use full capabilities
          </div>
          <div
            className="mt-2"
            style={{ color: theme.muted, fontSize: "0.9rem", lineHeight: 1.5 }}
          >
            Live chat, saved conversations, and guided follow-up prompts stay
            available for signed-in users.
          </div>
          <Link
            to="/signup"
            className="mt-3 rounded-pill px-3 py-2"
            style={{
              display: "inline-block",
              background: theme.button,
              color: "#FFFFFF",
              fontWeight: 700,
              fontSize: "0.9rem",
              textDecoration: "none",
            }}
          >
            Create a free account
          </Link>
        </div>
      </div>
    </div>
  );
};

export default CoTraderDemoLockedChatPanel;
